export const getAdmissionViewHref = (admissionId: string) =>
  `/admin/workflows/${admissionId}`;

export const getResidentProfileHref = (residentId: string) =>
  `/admin/residents/${residentId}`;
